module.exports = __webpack_public_path__ + "img/toonsync_code_toontorial.ba533002.webp";